import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { FormattedMessage } from "react-intl";

import DashCard from "../../components/DashCard";

import "../../static/style/dashboard.css";
import { fetchDebts, fetchInvoices } from "../../actions";
import { setUser } from "@sentry/react";

class Archive extends Component {
  constructor(props, context) {
    super(props, context);
    this.renderCards = this.renderCards.bind(this);
    this.state = {
      hasArchivedItems: false
    };
  }
  componentDidMount() {
    const token = sessionStorage.getItem("accessToken");
    if (token && !this.props.debts) {
      this.props.fetchDebts();
      this.props.fetchInvoices();
    }
  }

  renderCards(assData) {
    if (assData.tila === "M" || assData.tila === "LO") {
      let btns = [];

      if (this.state.hasArchivedItems === false) {
        this.setState({
          hasArchivedItems: true
        });
      }

      //Status & labels for Cards
      let color = "green";
      let tila = (
        <FormattedMessage
          id="app.dashcard.status_paid"
          defaultMessage="MAKSETTU"
        />
      );
      let name = assData.paamies.nimi;
      let open = assData.summa ? assData.summa : "0";
      let pd = assData.viimeisin_maksupaiva ? assData.viimeisin_maksupaiva : ""; // TODO: Find out if this is the correct value
      let paidDate = moment(pd, "YYYY-MM-DD");
      paidDate = paidDate.format("D.M.YYYY");

      let lblSum = (
        <FormattedMessage
          id="app.dashcard.paid_sum"
          defaultMessage="Maksettu summa"
        />
      );
      let bills;

      // Check if assignment has sent bills
      if (assData.kirje_set) {
        for (var index in assData.kirje_set) {
          if (assData.kirje_set[index].tiedostolinkki !== null) {
            bills.push(assData.kirje_set[index]);
          }
        }
        if (bills.length === 0) {
          bills = null;
        }
      } else {
        bills = null;
      }

      return (
        <DashCard
          key={assData.id}
          id={assData.id}
          nro={assData.nro}
          name={name}
          open={open}
          paid={paidDate}
          status={tila}
          lblSum={lblSum}
          border={color}
          buttons={btns}
          paymentForm={assData.paymentform}
          bills={bills}
          fetchPDF={this.props.fetchPDFFile}
        />
      );
    } else {
      return false;
    }
  }

  render() {
    if (!this.props.debts) {
      return (
        <div className="row">
          <div className="col-sm-12">
            <h1 className="header1">
              <FormattedMessage id="app.loading" defaultMessage="Ladataan..." />
            </h1>
          </div>
        </div>
      );
    }
    return (
      <div className="row">
        <div className="col-sm-12">
          <div>
            <h1 className="">
              <FormattedMessage
                id="app.archive.paid"
                defaultMessage="Laskuarkisto"
              />
            </h1>
            <ul className="list-unstyled">
              {this.props.invoices
                ? this.props.invoices.map(this.renderCards)
                : null}
              {this.props.debts ? this.props.debts.map(this.renderCards) : null}
            </ul>
          </div>
          {this.state.hasArchivedItems ? null : (
            <p>
              <FormattedMessage
                id="app.archive.no"
                defaultMessage="Ei maksettuja laskuja"
              />
            </p>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = function(store) {
  return {
    debts: store.debts.debts,
    installments: store.debts.installments,
    invoices: store.invoices.invoices
  };
};

const mapDispatchToProps = dispatch => ({
  fetchDebts: pin => dispatch(fetchDebts(pin)),
  fetchInvoices: pin => dispatch(fetchInvoices(pin)),
  setUser: user => dispatch(setUser(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(Archive);



// WEBPACK FOOTER //
// ./src/containers/Archive/Archive.js